export default function validateCaracteresAmount(field, value, max) {
  if (value.length > max) {
    throw new Error(`O campo ${field} não pode ultrapassar os ${max} caracteres.`);
  }
  return true;
}
